<div class="flex gap-3" [class]="isMobile ? 'flex-col-reverse' : 'flex-row'">
  <div class="thumbs" [class]="isMobile ? 'flex gap-2' : ''">
    <div
      *ngFor="let image of gallery.length > 0 ? gallery : ['../../../assets/images/image.png']; let i = index"
      class="cursor-pointer mb-2"
      (click)="goToSlide(i)"
    >
      <div
        class="w-[50px] aspect-square !bg-cover !bg-center"
        [ngStyle]="{ background: 'url(' + (image.image_url ?? image) + ')' }"
      ></div>
    </div>
  </div>

  <div class="aspect-square" [class]="isMobile ? 'w-[300px]' : 'w-[500px]'">
    <swiper-container
      class="w-full h-full"
      #swiper
      [pagination]="{ clickable: true }"
    >
      <swiper-slide
        *ngFor="let image of gallery.length > 0 ? gallery : ['../../../assets/images/image.png']; let i = index">
        <div
          class="w-full h-full !bg-cover !bg-center"
          [ngStyle]="{ background: 'url(' + (image.image_url ?? image) + ')' }"
        ></div>
      </swiper-slide>
    </swiper-container>
  </div>
</div>
